import { useCacheStorage } from '@/shared/lib/hooks/use-cache-storage';
import { CITypeListItem } from '@/entities/srm/ci';
import { useMemo } from 'react';
import { ciTypesListQueryConfig } from './ci-type-query-config';

export const useCITypeMapStorage = (key: keyof CITypeListItem = 'name') => {
  const { data, ...rest } = useCacheStorage<CITypeListItem[]>({
    queryConfig: ciTypesListQueryConfig,
  });
  const _data = useMemo(
    () => new Map(data?.map((el) => [el[key], el] as [string, CITypeListItem])),
    [data],
  );
  return { data: _data, ...rest };
};